(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-product-video"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.ttvVideoCardsReady) return;
  window.ttvVideoCardsReady = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.ttv-video-launch');
    if (!button || !button.dataset.videoSrc) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'ttv-video-dialog';
    dialog.setAttribute('aria-label', button.dataset.videoTitle);
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = button.dataset.videoClose;
    const heading = document.createElement('h2');
    heading.textContent = button.dataset.videoTitle;
    const video = document.createElement('video');
    video.controls = true;
    video.playsInline = true;
    video.preload = 'none';
    video.src = button.dataset.videoSrc;
    video.poster = button.querySelector('img')?.currentSrc || '';
    const error = document.createElement('p');
    error.hidden = true;
    error.setAttribute('role','status');
    error.textContent = button.dataset.videoError;
    video.addEventListener('error', () => { error.hidden = false; });
    dialog.append(close, heading, video, error);
    document.body.append(dialog);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.addEventListener('close', () => {
      video.pause();
      video.removeAttribute('src');
      video.load();
      document.body.style.overflow = previousOverflow;
      dialog.remove();
      button.focus();
    }, {once:true});
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => {if(e.target === dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    dialog.showModal();
    video.play().catch(() => {});
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ttv-video-card"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.ttvAdaptiveVideoCardsReady) return;
  window.ttvAdaptiveVideoCardsReady = true;
  let libraryPromise;

  const loadPlayer = url => {
    if (!libraryPromise) {
      libraryPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timeout = window.setTimeout(() => finish(new Error('Player timeout')), 10000);
        const finish = failure => {
          window.clearTimeout(timeout);
          script.onload = null;
          script.onerror = null;
          if (failure || !window.Hls) {
            script.remove();
            libraryPromise = null;
            reject(failure || new Error('Player unavailable'));
          } else {
            resolve(window.Hls);
          }
        };
        script.src = url;
        script.async = true;
        script.onload = () => finish();
        script.onerror = () => finish(new Error('Player unavailable'));
        document.head.append(script);
      });
    }
    return libraryPromise;
  };

  document.addEventListener('click', async event => {
    const button = event.target.closest('.ttv-adaptive-video-launch');
    if (!button || !button.dataset.videoSrc || document.querySelector('.ttv-video-dialog[open]')) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'ttv-video-dialog';
    dialog.setAttribute('aria-label', button.dataset.videoTitle);
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = button.dataset.videoClose;
    const heading = document.createElement('h2');
    heading.textContent = button.dataset.videoTitle;
    const video = document.createElement('video');
    video.controls = true;
    video.playsInline = true;
    video.preload = 'none';
    video.setAttribute('aria-label', button.dataset.videoTitle);
    video.poster = button.querySelector('img')?.currentSrc || '';
    const error = document.createElement('p');
    error.hidden = true;
    error.setAttribute('role', 'status');
    error.textContent = button.dataset.videoError;
    dialog.append(close, heading, video, error);
    document.body.append(dialog);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    let hls;
    let closed = false;
    let fallbackStarted = false;
    let recovered = false;
    const listeners = new AbortController();
    const options = {signal: listeners.signal};
    const play = () => {
      if (!closed) video.play().catch(() => {});
    };
    const fallback = () => {
      if (closed || fallbackStarted) return;
      fallbackStarted = true;
      const position = video.currentTime;
      const resume = !video.paused || position === 0;
      hls?.destroy();
      hls = null;
      video.dataset.playbackMode = 'mp4-fallback';
      video.addEventListener('loadedmetadata', () => {
        if (position > 0 && Number.isFinite(video.duration)) {
          video.currentTime = Math.min(position, Math.max(0, video.duration - 0.1));
        }
        if (resume) play();
      }, {...options, once: true});
      video.src = button.dataset.videoSrc;
      video.load();
      if (resume) play();
    };
    const nativePlayback = () => {
      if (closed) return;
      video.dataset.playbackMode = 'native-hls';
      video.src = button.dataset.videoHls;
      play();
    };
    video.addEventListener('error', () => {
      if (closed || hls) return;
      if (!fallbackStarted) fallback();
      else error.hidden = false;
    }, options);
    video.addEventListener('playing', () => {error.hidden = true;}, options);
    video.addEventListener('loadeddata', () => {
      video.dataset.startHeight = String(video.videoHeight);
    }, {...options, once: true});
    dialog.addEventListener('close', () => {
      closed = true;
      listeners.abort();
      hls?.destroy();
      hls = null;
      video.pause();
      video.removeAttribute('src');
      video.load();
      document.body.style.overflow = previousOverflow;
      dialog.remove();
      button.focus();
    }, {once: true});
    close.addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close();
    }, options);
    dialog.showModal();
    const nativeSupported = !!video.canPlayType('application/vnd.apple.mpegurl');
    if (!button.dataset.videoHls) {
      fallback();
      return;
    }
    if (!window.MediaSource && !window.ManagedMediaSource && nativeSupported) {
      nativePlayback();
      return;
    }
    try {
      const Hls = await loadPlayer(button.dataset.videoPlayer);
      if (closed) return;
      if (!Hls.isSupported()) {
        if (nativeSupported) nativePlayback();
        else fallback();
        return;
      }
      hls = new Hls({autoStartLoad: false, capLevelToPlayerSize: false, maxBufferLength: 10, maxMaxBufferLength: 20});
      video.dataset.playbackMode = 'adaptive-hls';
      hls.once(Hls.Events.MANIFEST_PARSED, (_, data) => {
        if (closed || !hls) return;
        const lowest = data.levels.reduce((best, level, index) => level.bitrate < data.levels[best].bitrate ? index : best, 0);
        hls.startLevel = lowest;
        hls.startLoad(0);
        play();
      });
      hls.on(Hls.Events.ERROR, (_, data) => {
        if (!data.fatal || closed || !hls) return;
        if (data.type === Hls.ErrorTypes.MEDIA_ERROR && video.error && !recovered) {
          recovered = true;
          hls.recoverMediaError();
        } else {
          fallback();
        }
      });
      hls.attachMedia(video);
      hls.loadSource(button.dataset.videoHls);
    } catch {
      if (nativeSupported) nativePlayback();
      else fallback();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
